import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { CustomSettingModel } from "@TKCCP/Types/ApiModels";

export function getCustomSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.customSettingsSettings as CustomSettingModel | undefined;
}
